import ReactGA from 'react-ga4';

export function initAnalytics() {
  const id = process.env.REACT_APP_GA_ID;
  if (id) {
    ReactGA.initialize(id);
  }
}

export function trackPageView(path) {
  const page = path || (typeof window !== 'undefined' ? window.location.pathname + window.location.search : '');
  ReactGA.send({ hitType: 'pageview', page });
}

export function trackEvent(eventName, params = {}) {
  ReactGA.event(eventName, params);
}

export function getCampaignSource(search) {
  const params = new URLSearchParams(
    search || (typeof window !== 'undefined' ? window.location.search : '')
  );
  return params.get('src');
}
